import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch } from "react-router";
import { RouterState, push } from "connected-react-router";

import ErrorBoundary from "../ErrorBoundary";
import AuthComponent from "../auth/AuthComponent";
import useCheckSession from "../../hooks/useCheckSession";
import useInitialRouting from "../../hooks/useInitialRouting";
import { ApplicationState } from "../../store";
import { APIState } from "../../store/API/types";
import { getAPIData, startHeartBeaten } from "../../store/API/actions";
import LivemodeComponent from "../livemode/LivemodeComponent";
import BrowsemodeComponent from "../browsemode/BrowsemodeComponent";
import FooterComponent from "../footer/FooterComponent";
import PreloadComponent from "../PreloadComponent/PreloadComponent";
import BookmarkContainer from "../../containers/BookmarkContainer";
import AlertComponent from "../alerts/AlertComponent";
import SessionIsOutComponent from "../reusable/SessionIsOutComponent/SessionIsOutComponent";
import useCheckServerAddress from '../../hooks/useCheckServerAddress';
import { Redirect } from 'react-router-dom';
import useCheckCayugaCerts from '../../hooks/useCheckCayugaCerts';
import SpinnerComponent from '../reusable/SpinnerComponent';

const MainPageComponent = () => {
  const {layouts, cameras, sessionTokenIsOver, token, privileges} = useSelector<ApplicationState, APIState>(state => state.API);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const path = location.pathname;


  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAPIData());
    dispatch(startHeartBeaten());
  }, []);

  useEffect(() => {
    if (token && (path === `/browse`) && (privileges && !privileges.canBrowse)) dispatch(push('live'));
    if (token && (path === `/bookmarks`) && (privileges && (!privileges.canBrowse || !privileges.canViewBookmarks))) dispatch(push('live'));
  }, [privileges]);

  if (!cameras || !layouts) return null;

  return (
    <div className='h-100 w-100'>
      <ErrorBoundary>
        <PreloadComponent>
          <Switch>
            <Route path={`/live`} exact component={LivemodeComponent}/>
            <Route path={`/browse`} exact component={BrowsemodeComponent}/>
            <Route path={`/bookmarks`} exact component={BookmarkContainer}/>
            <Route path={`/alerts`} exact component={AlertComponent}/>
            <Redirect to={`/live`}/>
          </Switch>
          <FooterComponent/>
        </PreloadComponent>
      </ErrorBoundary>
      {
        sessionTokenIsOver && <SessionIsOutComponent/>
      }
    </div>
  )
};

const RouterComponent: React.FC = () => {
  const {token} = useSelector<ApplicationState, APIState>(state => state.API);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);

  const isValid = useCheckCayugaCerts();
  useCheckServerAddress();
  useCheckSession();
  useInitialRouting();

  if (!isValid) return <div className={`full-screen flex al-it-c js-c`}>
    <SpinnerComponent/>
  </div>;
  if (!token && location.pathname !== '/auth') return null;

  return (
    <Switch>
      <Route path={`/auth`} exact component={AuthComponent}/>
      <Route path={`/`} component={MainPageComponent}/>
      <Redirect to={`/`}/>
    </Switch>
  )
};

export default RouterComponent